var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78.242,
    viewBox: "0 0 78 78.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock_1_",
    "data-name": "clock (1)",
    transform: "translate(-0.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M255.29,15h-.08V88.545l1.872-.091A36.749,36.749,0,0,0,255.29,15Z",
    transform: "translate(-215.541 -12.708)",
    fill: "#ff865d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M268.891,135.725a2.295,2.295,0,0,1-3.243,0l-16.793-16.793-1.146-14.016,1.146-14.536a2.292,2.292,0,0,1,2.292,2.292V114.74l17.743,17.742A2.3,2.3,0,0,1,268.891,135.725Z",
    transform: "translate(-209.186 -76.568)",
    fill: "#15171a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(37.377 13.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M242.5,90.38v28.552l-1.621-1.621a2.3,2.3,0,0,1-.671-1.621V92.672A2.292,2.292,0,0,1,242.5,90.38Z",
    transform: "translate(-240.209 -90.38)",
    fill: "#333940"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M290.094,39.121a39.12,39.12,0,0,1-39.121,39.121l-.764-2.292.764-2.292a34.536,34.536,0,0,0,0-69.073l-.764-2.5L250.973,0a39.12,39.12,0,0,1,39.121,39.121Z",
    transform: "translate(-211.304)",
    fill: "#15171a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(0.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(36.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M242.5,0V4.584A2.292,2.292,0,1,1,242.5,0Z",
    transform: "translate(-240.209)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M242.5,482v4.584a2.292,2.292,0,0,1,0-4.584Z",
    transform: "translate(-240.209 -408.343)",
    fill: "#333940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(0 1.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M155.342,13.682a2.287,2.287,0,0,0,.85-.164c.008,0,.824-.328,1.7-.6.939-.293,2.048-.607,2.059-.61a2.292,2.292,0,0,0-1.246-4.412c-.048.013-1.18.334-2.181.646-1.055.33-2,.706-2.038.722a2.292,2.292,0,0,0,.853,4.42Z",
    transform: "translate(-129.781 -7.806)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M84.085,44.4c-.04.029-.989.726-1.816,1.369-.873.678-1.625,1.362-1.657,1.39a2.292,2.292,0,0,0,3.086,3.39c.007-.006.657-.6,1.384-1.161.777-.6,1.706-1.286,1.715-1.293a2.292,2.292,0,1,0-2.713-3.7Z",
    transform: "translate(-67.78 -38.432)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M32.694,105.435a2.292,2.292,0,0,0-3.174.662c-.027.041-.672,1.026-1.222,1.918-.58.941-1.045,1.844-1.065,1.883a2.292,2.292,0,0,0,4.078,2.095c0-.008.406-.789.889-1.572.516-.837,1.148-1.8,1.154-1.812A2.292,2.292,0,0,0,32.694,105.435Z",
    transform: "translate(-22.978 -90.198)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M3.136,192.071a2.338,2.338,0,0,0,.27.016,2.293,2.293,0,0,0,2.274-2.025c0-.009.1-.872.283-1.783.19-.965.444-2.089.446-2.1a2.292,2.292,0,1,0-4.472-1.01c-.011.048-.27,1.2-.473,2.225-.213,1.084-.333,2.093-.338,2.135a2.292,2.292,0,0,0,2.01,2.544Z",
    transform: "translate(-1.061 -156.549)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M6.031,274.875c0-.008-.209-.853-.36-1.769-.16-.97-.316-2.113-.318-2.124a2.292,2.292,0,0,0-4.542.62c.007.049.166,1.215.336,2.249.18,1.09.421,2.078.432,2.119a2.292,2.292,0,1,0,4.452-1.1Z",
    transform: "translate(-0.789 -229.085)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M31.112,354.158c-.489-.853-1.036-1.868-1.042-1.879a2.292,2.292,0,0,0-4.037,2.172c.023.044.581,1.08,1.1,1.989.55.958,1.122,1.8,1.146,1.834a2.292,2.292,0,0,0,3.787-2.584C32.064,355.682,31.57,354.956,31.112,354.158Z",
    transform: "translate(-21.943 -298.616)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M84.759,422.268c-.007-.005-.724-.512-1.433-1.1-.757-.627-1.625-1.387-1.633-1.395a2.292,2.292,0,0,0-3.021,3.448c.037.033.923.808,1.73,1.477.851.705,1.681,1.292,1.716,1.316a2.292,2.292,0,0,0,2.642-3.747Z",
    transform: "translate(-66.108 -356.337)",
    fill: "#333940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M157.423,466.172c-.009,0-.849-.223-1.726-.528-.929-.323-2.008-.73-2.018-.735a2.292,2.292,0,1,0-1.623,4.288c.046.018,1.147.434,2.137.778,1.044.362,2.026.621,2.068.632a2.292,2.292,0,0,0,1.162-4.435Z",
    transform: "translate(-127.685 -394.931)",
    fill: "#333940"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a426b6c85017b1f0c69622f1b3933dd7.svg";
export { ForwardRef as ReactComponent };